import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import {getGushHelkaTTHelkaRTLString} from '../../../utils/texts';
import styles from './styles.module.scss';

const Section6Text0 = React.forwardRef(({}, ref) => {
  const {
    data: {
      pdfData: {
        streetName,
        cityName,
        propertyTypeName,
        gush, helka, ttHelka,
      },
    }
  } = useCompleteInspectionContext();
  
  return (
    <div className={classnames(styles.itemText, styles.innerPadding)} ref={ref}>
      {[
        'הנכס שבנדון מהווה',
        propertyTypeName,
        "בבנין הממוקם ברח'",
        streetName,
        `${cityName},`,
        'בגו"ח',
        getGushHelkaTTHelkaRTLString({gush, helka, ttHelka})
      ].filter(Boolean).join(' ')}.
    </div>
  );
});

export default Section6Text0;
